import { CommonBaseData } from "../shared/data/common-base-data";
import { N202A06OutData } from "../shared/webapi-data/n202a06-out-data";

export class N2025OutputData extends CommonBaseData  {
  // 希望車種名リスト
  public apiOutData: N202A06OutData;
}



// WEBPACK FOOTER //
// ./src/app/modules/n202/n2025-output-data.ts